// extracted by mini-css-extract-plugin
export var container = "_54-0";
export var disabled = "_54-4";
export var fullWidth = "_54-3";
export var lined = "_54-1";
export var selected = "_54-5";
export var tab = "_54-2";